import { defineCommerceEngine as defineBaseCommerceEngine, SolutionType, } from '@coveo/headless/ssr-commerce';
// Workaround to prevent Next.js erroring about importing CSR only hooks
import React from 'react';
import { singleton } from '../utils.js';
import { buildControllerHooks, buildEngineHook, buildHydratedStateProvider, buildStaticStateProvider, } from './common.js';
// Wrapper to workaround the limitation that `createContext()` cannot be called directly during SSR in next.js
export function createSingletonContext() {
    return singleton(() => React.createContext(null));
}
/**
 * Returns engine and controller hooks, and context providers.
 *
 * See [Define the commerce engine and controllers](docs.coveo.com/en/obif0156#define-the-commerce-engine-and-controllers).
 *
 * @group Engine
 */
export function defineCommerceEngine(options) {
    const singletonContext = createSingletonContext();
    const { listingEngineDefinition, searchEngineDefinition, standaloneEngineDefinition, recommendationEngineDefinition, } = defineBaseCommerceEngine({ ...options });
    return {
        useEngine: buildEngineHook(singletonContext),
        controllers: buildControllerHooks(singletonContext, options.controllers),
        listingEngineDefinition: {
            ...listingEngineDefinition,
            StaticStateProvider: buildStaticStateProvider(singletonContext, SolutionType.listing),
            HydratedStateProvider: buildHydratedStateProvider(singletonContext, SolutionType.listing),
        },
        searchEngineDefinition: {
            ...searchEngineDefinition,
            StaticStateProvider: buildStaticStateProvider(singletonContext, SolutionType.search),
            HydratedStateProvider: buildHydratedStateProvider(singletonContext, SolutionType.search),
        },
        standaloneEngineDefinition: {
            ...standaloneEngineDefinition,
            StaticStateProvider: buildStaticStateProvider(singletonContext, SolutionType.standalone),
            HydratedStateProvider: buildHydratedStateProvider(singletonContext, SolutionType.standalone),
        },
        recommendationEngineDefinition: {
            ...recommendationEngineDefinition,
            StaticStateProvider: buildStaticStateProvider(singletonContext, SolutionType.recommendation),
            HydratedStateProvider: buildHydratedStateProvider(singletonContext, SolutionType.recommendation),
        },
    };
}
//# sourceMappingURL=commerce-engine.js.map